// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__2zCtm","radioRow":"SimpleQuestionBuilderModal_radioRow__lvnVD"};